import graphQLClient from "../../utils/authHeader";

import CREATE_SUBSCRIPTION from "../../utils/mutations/subscriptions/createSubsciption";
import VERIFY_LOCK_TOKEN_TRX from "../../utils/mutations/subscriptions/verifyLockTokenTrxInput";
import SUBSCRIPTION_PLANS_QUERY from "../../utils/queries/subscriptions/getSubscriptionPlans";
import GET_USER_SUBSCRIPTIONS from "../../utils/queries/subscriptions/getUserSubscriptions";
import CANCEL_SUBSCRIPTION from "../../utils/mutations/subscriptions/cancelSubscription";
import RELOCK_TOKEN from "../../utils/mutations/subscriptions/relockToken";
import VERIFY_UNLOCK_TRANSACTION from "../../utils/mutations/subscriptions/verifyUnlockTokenTransaction";

export const GetSubscriptionPlans = async () => {
  return new Promise((resolve, reject) => {
    graphQLClient
      .request(SUBSCRIPTION_PLANS_QUERY)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const GetUserSubscriptions = async () => {
  return new Promise((resolve, reject) => {
    graphQLClient
      .request(GET_USER_SUBSCRIPTIONS)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const CreateSubscription = async (
  totalToken: number,
  duration: number,
  walletAddress: string,
  networkId: any
) => {
  return new Promise((resolve, reject) => {
    const variables = {
      totalToken: totalToken,
      duration: duration,
      walletAddress: walletAddress,
      networkId: networkId,
    };
    graphQLClient
      .request(CREATE_SUBSCRIPTION, variables)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const VerifyLockTokenTransaction = async (
  lockTokenId: string,
  trxHash: string,
  walletAddress: string
) => {
  return new Promise((resolve, reject) => {
    const variables = {
      lockTokenId: lockTokenId,
      trxHash: trxHash,
      walletAddress: walletAddress,
    };
    graphQLClient
      .request(VERIFY_LOCK_TOKEN_TRX, variables)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const CancelSubscription = async (subscriptionId: string, reason: string) => {
  return new Promise((resolve, reject) => {
    const variables = {
      subscriptionId: subscriptionId,
      cancellationReason: reason,
    };
    graphQLClient
      .request(CANCEL_SUBSCRIPTION, variables)
      .then((data) => resolve(data))
      .catch((error) => reject(error.response));
  });
};

export const RelockSubscription = (subscriptionId: any) => {
  return new Promise((resolve, reject) => {
    const variables = {
      subscriptionId: subscriptionId,
    };
    graphQLClient
      .request(RELOCK_TOKEN, variables)
      .then((data) => resolve(data))
      .catch((error) => reject(error.response));
  });
};

export const VerifyUnlockTokenTransaction = (
  lockTokenId: any,
  trxHash: any,
  walletAddress: any
) => {
  return new Promise((resolve, reject) => {
    const variables = {
      lockTokenId: lockTokenId,
      trxHash: trxHash,
      walletAddress: walletAddress,
    };
    graphQLClient
      .request(VERIFY_UNLOCK_TRANSACTION, variables)
      .then((data) => resolve(data))
      .catch((error) => reject(error.response));
  });
};
